import { Table, Tag, Tooltip } from "antd";
import "../../table-compact.css";

const statusColor = {
  Normal: "success",
  Warning: "warning",
  Danger: "error",
  Cepat: "success",
};

// normalisasi status API ("normal"/"warning"/"danger") ke label Title Case
const prettyStatus = (s) => {
  const t = String(s ?? "").toLowerCase();
  if (!t) return "-";
  return t.charAt(0).toUpperCase() + t.slice(1);
};

export default function ClearanceTable({ data }) {
  const columns = [
    { title: "No", dataIndex: "no", width: 34, align: "center" },
    { title: "Nomor BL/AWB", dataIndex: "blAwb", width: 105 },
    {
      title: "Consignee",
      dataIndex: "consignee",
      width: 112,
      ellipsis: { showTitle: false },
      render: (v) => {
        const s = String(v ?? "-");
        const short = s.length > 10 ? `${s.slice(0, 10)}...` : s;
        return <Tooltip title={s}>{short}</Tooltip>;
      },
    },
    { title: "Waktu Tiba (Bongkar)", dataIndex: "arrival", width: 130 },
    { title: "Waktu Keluar (Gate Out)", dataIndex: "gateOut", width: 130 },
    { title: "Clearance Time", dataIndex: "clearance", width: 112 },
    {
      title: "Status",
      dataIndex: "status",
      width: 84,
      render: (status) => {
        const label = prettyStatus(status);
        return (
          <Tag color={statusColor[label] || "default"} className="status-tag">
            <span className="status-dot" />
            {label}
          </Tag>
        );
      },
    },
  ];
  return (
    <Table
      className="clearance-table bv2-compact"
      columns={columns}
      dataSource={data}
      pagination={false}
      size="small"
      bordered
      scroll={{ x: 700 }}
      rowKey="key"
    />
  );
}
